import { defineAsyncComponent } from 'vue'
export default {
  app: defineAsyncComponent(() => import("/var/www/html/fullstack-saas/frontend/layouts/app.vue").then(m => m.default || m)),
  apps: defineAsyncComponent(() => import("/var/www/html/fullstack-saas/frontend/layouts/apps.vue").then(m => m.default || m)),
  auth: defineAsyncComponent(() => import("/var/www/html/fullstack-saas/frontend/layouts/auth.vue").then(m => m.default || m)),
  default: defineAsyncComponent(() => import("/var/www/html/fullstack-saas/frontend/layouts/default.vue").then(m => m.default || m))
}